import injector from 'vue-inject'
import shortid from 'shortid'

class requestBuilder {
  build (cart, orderParams, menu) {
    const assignNextLevelValues = {
      radio (values, question) {
        if (question.selectedOption.questions) {
          question.selectedOption.questions.forEach(subQuestion => { // subQuestions
            if (subQuestion.value) {
              values[subQuestion.id] = { value: subQuestion.value }
              values[subQuestion.id].instanceId = shortid.generate()
            }
          })
        }
      },
      switch (values, question) {
        if (question.value) {
          question.selectedOption.questions.forEach(subQuestion => {
            if (subQuestion.value) {
              values[subQuestion.id] = { value: subQuestion.value }
              values[subQuestion.id].instanceId = shortid.generate()
            }
          })
        }
      },
      numberGroup (values, question) {}
    }

    const buildQuestion = injector.get('CartElementBuilder').buildQuestion

    orderParams['items'] = Object.keys(cart).map(k => cart[k]).map(itemsWithSameItemId =>
      Object.keys(itemsWithSameItemId).map(k => itemsWithSameItemId[k]).map(itemObj => {
        const values = {}
        if (menu.items[itemObj.id].questions) {
          // 重頭到尾掃過每個 question 把它們的值複製到新的 value 裡面
          // 不要用原本的 itemObje.values 的原因是為了防止那些第一層已經取消但第二層的值還被保留的問題的值也被留下來
          menu.items[itemObj.id].questions.forEach(qid => {
            if (itemObj.values[qid]) {
              values[qid] = itemObj.values[qid]
              values[qid].instanceId = shortid.generate()
            }
            const question = buildQuestion(qid, itemObj, menu)
            assignNextLevelValues[question.type](values, question)
          })
        }
        return {
          id: itemObj.id,
          instanceId: itemObj.instanceId,
          specialRequests: itemObj.specialRequests,
          values
        }
      }).reduce((a, b) => a.concat(b), [])).reduce((a, b) => a.concat(b), [])
    return JSON.parse(JSON.stringify(orderParams))
  }
}

injector.service('requestBuilder', [], requestBuilder)
